import { redirect } from "next/navigation";

export const getNotifications = async (page?: number, size?: number) => {
	const url = new URL(
		`${process.env.NEXT_PUBLIC_BASE_URL}/api/user/notifications`,
	);

	if (page && /^[1-9]\d*$/.test(String(page))) {
		url.searchParams.append("page", String(Number(page) - 1));
	}

	if (size && /^[1-9]\d*$/.test(String(size))) {
		url.searchParams.append("size", String(size));
	}

	const res = await fetch(url, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
		cache: "no-store",
	});

	if (res.status === 401) {
		redirect("/");
	}

	if (!res.ok) throw new Error("Failed to fetch user notifications");

	return res.json();
};
